import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import GitstreamResults from './GitstreamResults';
import { AutomationsMarkdown } from './AutomationsMarkdown';
import { useFullscreen } from '../hooks/useFullscreen';
import { ResultBox, ResultTab, ResultsTabs } from './ResultsSection.style';
import JsonTreeView from './JsonTreeView';
import { OutputContainer, PlaygroundLayout } from '../Playground.style';
import { FullscreenButton } from './FullscreenButton';
import { StyledLoaderWrapper } from '../../dashboard/components/CardController/CardController.style';
import { Loader } from '@linearb/linui-common';
import styled from '@emotion/styled';

const CustomTabPanel = props => {
  const { children, value, index, ...other } = props;

  return (
    <span
      key={index}
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box key={index}>
          <Typography
            component={'span'}
            key={index}
            sx={{ fontSize: '1.25rem' }}
          >
            {children}
          </Typography>
        </Box>
      )}
    </span>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

const setProps = index => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
};

const StyledOutputContainer = styled(OutputContainer)`
  background-color: ${({ isMarkdownTab }) =>
    isMarkdownTab ? '#fff' : '#2e2e2e'};
`;

const ResultsSection = ({
  results,
  ruleFileErrors,
  gitstreamErrors,
  gitstreamAutomations,
  loading,
  context
}) => {
  const [value, setValue] = useState(0);
  const containerRef = useRef(null);
  const [isFullscreen, handleToggleFullscreen] = useFullscreen(containerRef);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PlaygroundLayout isFullscreen={isFullscreen}>
      <Box sx={{ width: '100%', position: 'relative' }} ref={containerRef}>
        <ResultBox>
          <ResultsTabs value={value} onChange={handleChange}>
            <ResultTab label='Output' {...setProps(0)} />
            <ResultTab label='Markdown' {...setProps(1)} />
            <ResultTab label='Context Variables' {...setProps(2)} />
          </ResultsTabs>
          <Box sx={{ position: 'absolute', right: 0, top: 0 }}>
            <FullscreenButton
              isFullscreen={isFullscreen}
              onToggle={handleToggleFullscreen}
            />
          </Box>
        </ResultBox>

        <StyledOutputContainer
          isMarkdownTab={value === 1}
          isFullscreen={isFullscreen}
        >
          {loading && (
            <StyledLoaderWrapper>
              <Loader />
            </StyledLoaderWrapper>
          )}

          <CustomTabPanel value={value} index={0}>
            <GitstreamResults
              ruleFileErrors={ruleFileErrors}
              gitstreamErrors={gitstreamErrors}
              gitstreamResults={results}
            />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <AutomationsMarkdown gitstreamAutomations={gitstreamAutomations} />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            {context && <JsonTreeView context={context} />}
          </CustomTabPanel>
        </StyledOutputContainer>
      </Box>
    </PlaygroundLayout>
  );
};

export default ResultsSection;
